import { render } from "./AppNoCountPagination.vue?vue&type=template&id=c21b0ed2"
import script from "./AppNoCountPagination.vue?vue&type=script&lang=js"
export * from "./AppNoCountPagination.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__